import { createStore } from './createStore.js';

/** Score-keeping for the hidden "Who's that Pokémon?" game (#/whos-that). */
export const whosThat = createStore('pdx.whosThat', { best: 0, plays: 0, wins: 0, gen: 0 });

export function recordResult(win, streak) {
  whosThat.set((s) => ({
    ...s,
    plays: s.plays + 1,
    wins: s.wins + (win ? 1 : 0),
    best: Math.max(s.best, streak),
  }));
}
